import React from 'react';
import {
  ArrayInput,
  Create,
  Datagrid,
  List,
  maxLength,
  minLength,
  required,
  SimpleFormIterator,
  TextInput,
} from 'react-admin';

import { ZippitySimpleForm } from '../../components';
import ConditionOptionsChipField from './ConditionOptionsChipField';
import BulkDeleteButton from '../../components/BulkDeleteButton';

export const ConditionOptionsList = (props) => (
  <div>
    <List {...props} perPage={50} bulkActionButtons={<BulkDeleteButton />}>
      <Datagrid>
        <ConditionOptionsChipField source="options" sortable={false} />
      </Datagrid>
    </List>
  </div>
);

const validateRequiredString = [required(), minLength(2), maxLength(63)];

// Set initial value so we have at least one Condition Option
const initialValue = { options: [''] };

export const ConditionOptionsCreate = (props) => (
  <Create {...props}>
    <ZippitySimpleForm initialValues={initialValue}>
      <ArrayInput source="options" validate={[required(), minLength(1)]}>
        <SimpleFormIterator>
          <TextInput label="" validate={validateRequiredString} />
        </SimpleFormIterator>
      </ArrayInput>
    </ZippitySimpleForm>
  </Create>
);
